const PREFIX = "pl-bill-tooltip-item";

export const PL_BILL_TOOLTIP_ITEM_TEST_IDS = {
    TRIGGER_AREA: `${PREFIX}-trigger-area`,
    TOOLTIP_CONTAINER: `${PREFIX}-tooltip-container`,
    LEFT_INFO_TEXT: `${PREFIX}-left-info-text`,
    RIGHT_INFO_TEXT: `${PREFIX}-right-info-text`,
    SUB_LINE_TITLE_ROW: `${PREFIX}-sub-line-title-row`,
    SUB_LINE_DISPLAY_ROW: `${PREFIX}-sub-line-display-row`,
};
